import { render, staticRenderFns } from "./backhaulConfigurationJL.vue?vue&type=template&id=24d5f55e&scoped=true&"
import script from "./backhaulConfigurationJL.vue?vue&type=script&lang=js&"
export * from "./backhaulConfigurationJL.vue?vue&type=script&lang=js&"
import style0 from "./backhaulConfigurationJL.vue?vue&type=style&index=0&id=24d5f55e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d5f55e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24d5f55e')) {
      api.createRecord('24d5f55e', component.options)
    } else {
      api.reload('24d5f55e', component.options)
    }
    module.hot.accept("./backhaulConfigurationJL.vue?vue&type=template&id=24d5f55e&scoped=true&", function () {
      api.rerender('24d5f55e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/financial/backhaulConfigurationJL.vue"
export default component.exports